import { AloLogbookItem, IAloLogbookItemConstParam } from './AloLogbookItem'

export interface IAloLogbookChannelConstParam  {
    misId:number
    messageArray:Array<IAloLogbookItemConstParam>    
  }

export class AloLogbookChannel {
        
    public misId:number
    public messageArray:Array<AloLogbookItem>

    constructor({misId = 0, messageArray = [] }:IAloLogbookChannelConstParam = {} as IAloLogbookChannelConstParam) {
        this.misId = misId
        this.messageArray = messageArray.map(message => AloLogbookItem.createAloLogbookItem(message))
    }

    static createAloLogbookChannel(data:any) {
        return new AloLogbookChannel(data)
    }
}